import { fabric } from 'fabric';

type BeatSelectionCtor = new (
  // callers also pass y1/y2; the constructor below only reads x1/x2 - pre-existing.
  cv: fabric.Canvas,
  points: { x1: number; x2: number; y1?: number; y2?: number },
  offsetX: number,
  config: any,
  isDelete: boolean,
) => any;

let BeatSelectionImpl: any;

(function () {
  const STROKE_BASE = {
    selectable: false,
    hasControls: false,
    hasBorders: false,
    hasRotatingPoint: false,
    selection: false,
    skipTargetFind: false,
    editable: false,
    strokeWidth: 1,
  };
  const STROKE_BLUE = {
    ...STROKE_BASE,
    fill: '#0B68E510',
    stroke: '#0B68E5',
  };

  const STROKE_RED = {
    ...STROKE_BASE,
    fill: '#F23D4210',
    stroke: '#F23D42',
  };

  BeatSelectionImpl = function (
    cv: fabric.Canvas,
    points: { x1: number; x2: number },
    offsetX: number,
    config: any,
    isDelete: boolean,
  ) {
    this.type = 'BeatSelection';
    this.canvas = cv;
    this.config = config;
    this.x1 = points.x1;
    this.x2 = points.x2;
    this.height = this.config.height;
    this.width = this.x2 - this.x1;
    this.left = Math.min(this.x1, this.x2);
    this.spp = (config.samplingRate * config.wndDuration) / config.width;
    this.xr = offsetX + this.x1 * this.spp;
    this.isDelete = isDelete;
  };

  BeatSelectionImpl.prototype.draw = function () {
    this.rect = new fabric.Rect({
      left: this.left,
      top: 0,
      width: this.width,
      height: this.width > 2 ? this.height : 0, // If user click and release right after => do not show rectangle
      ...(this.isDelete ? STROKE_RED : STROKE_BLUE),
    });
    this.canvas.add(this.rect);
    this.render();
  };

  BeatSelectionImpl.prototype.render = function () {
    if (
      !(
        (this.x1 < 0 && this.x2 < 0) ||
        (this.x1 > this.config.width && this.x2 > this.config.width)
      )
    ) {
      this.canvas.renderAll();
    }
  };

  BeatSelectionImpl.prototype.update = function (
    delta: { dx: number },
    isScrolling: boolean,
    leValue: number,
    isDelete: boolean,
  ) {
    this.x2 = !isScrolling ? this.x2 + delta.dx : leValue;
    const startH = Math.min(this.x1, this.x2);
    const endH = Math.max(this.x1, this.x2);
    this.width = endH - startH;
    this.left = startH;
    this.rect.set({
      width: this.width,
      left: this.left,
      height: this.height,
      top: 0,
      ...(this.isDelete ? STROKE_RED : STROKE_BLUE),
    });
    this.render();
  };

  BeatSelectionImpl.prototype.scroll = function (offsetX: number) {
    const d = this.x2 - this.x1;
    this.x1 = (this.xr - offsetX) / this.spp;
    this.x2 = this.x1 + d;
    const startH = Math.min(this.x1, this.x2);
    const endH = Math.max(this.x1, this.x2);
    this.width = endH - startH;
    this.rect.set({
      width: this.width,
      left: startH,
    });
  };

  BeatSelectionImpl.prototype.delete = function () {
    this.canvas.remove(this.rect);
    this.rect = null;
  };

  BeatSelectionImpl.prototype.getJSONObject = function () {
    return {
      type: this.type,
      position: this.xr,
    };
  };
})();

const BeatSelection: BeatSelectionCtor = BeatSelectionImpl;

export { BeatSelection };
export default { BeatSelection };
